/**
 * El bloque donde el cliente nos dice cuanto gasta: la planilla, el numero, o los dos.
 *
 * No son excluyentes a proposito, y no es un descuido de diseño. Si llegan los dos, el
 * servidor cotiza con la planilla —es el dato real— y compara: si no se parecen, el
 * asesor recibe un aviso arriba del correo de que la lectura pudo fallar. Esa
 * comprobacion cruzada solo existe si dejamos que la persona rellene ambos.
 *
 * Por eso el segundo campo dice "o escribelo" y no "elige una opcion".
 */

import { CampoTexto } from './CampoTexto.js'
import { SubirPlanilla } from './SubirPlanilla.js'

interface Props {
  archivo: File | null
  onArchivo: (archivo: File | null) => void
  consumoKwh: string
  onConsumo: (valor: string) => void
  errorPlanilla?: string | undefined
  errorConsumo?: string | undefined
  /** La recomendacion en pantalla. Va dentro del bloque porque habla de este dato. */
  children?: React.ReactNode
}

export function BloqueConsumo({
  archivo,
  onArchivo,
  consumoKwh,
  onConsumo,
  errorPlanilla,
  errorConsumo,
  children,
}: Props) {
  return (
    <fieldset className="bloque-consumo">
      <legend>¿Cuánta luz consumes?</legend>
      <p className="ayuda-bloque">
        Es el dato que decide el tamaño del sistema. Con tu planilla el cálculo es exacto;
        si no la tienes a mano, el consumo aproximado también nos sirve para empezar.
      </p>

      <SubirPlanilla archivo={archivo} onCambio={onArchivo} error={errorPlanilla} />

      <div className="separador-o">
        <span>o</span>
      </div>

      <CampoTexto
        id="consumoKwh"
        etiqueta="Escribe tu consumo mensual"
        valor={consumoKwh}
        onCambio={onConsumo}
        tipo="number"
        inputMode="numeric"
        sufijo="kWh al mes"
        ayuda="Búscalo en tu planilla, donde dice consumo del mes. Una casa mediana ronda los 300 kWh."
        error={errorConsumo}
      />

      {children}
    </fieldset>
  )
}
